const STORED_SEARCH = 'STORED_SEARCH';

interface SearchData {
  pagina :string;
  resultado :any;
}

export function salvarPesquisa(pagina :string, resultado :any){
  const dados : SearchData = {
    pagina: pagina,
    resultado: resultado
  }
  sessionStorage.setItem(STORED_SEARCH, JSON.stringify(dados));
}

export function obterPesquisa(pagina :string){
  const res = sessionStorage.getItem(STORED_SEARCH);
  if (!res)
    return null;
  const dados : SearchData = JSON.parse(res);
  if (dados.pagina !== pagina){
    limparPesquisaSalva();
    return null;
  }
  return dados.resultado;
}

export function limparPesquisaSalva(){
  sessionStorage.removeItem(STORED_SEARCH);
}

export function limparResultadoSalvo(campo :string, idExcluido :number){
  const res = sessionStorage.getItem(STORED_SEARCH);
  if (!res)
    return ;
  const dados : SearchData = JSON.parse(res);
  dados.resultado.resultado = dados.resultado.resultado.filter( (item:any) => item[campo] !== idExcluido );
  sessionStorage.setItem(STORED_SEARCH, JSON.stringify(dados));
}
